import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AppLayout } from '@/components/layout/app-layout';
import { RequireAuth } from '@/components/layout/require-auth';
import { PageSpinner } from '@/components/ui/spinner';
import LandingPage from '@/pages/landing-page';
import { useMotionReady } from '@/hooks/use-motion';

// Route-level code splitting keeps the landing page fast.
const RestaurantSelectPage = lazy(() => import('@/pages/restaurant-select-page'));
const ScanPage = lazy(() => import('@/pages/scan-page'));
const ReportPage = lazy(() => import('@/pages/report-page'));
const DashboardPage = lazy(() => import('@/pages/dashboard-page'));
const NotFoundPage = lazy(() => import('@/pages/not-found-page'));
const LoginPage = lazy(() => import('@/pages/auth-pages').then((m) => ({ default: m.LoginPage })));
const RegisterPage = lazy(() =>
  import('@/pages/auth-pages').then((m) => ({ default: m.RegisterPage })),
);

function DashboardScanRedirect() {
  const { id } = useParams();
  return <Navigate to={`/report/${id}`} replace />;
}

export default function App() {
  useMotionReady();
  return (
    <Suspense fallback={<PageSpinner />}>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="grade" element={<RestaurantSelectPage />} />
          <Route path="restaurant/select" element={<RestaurantSelectPage />} />
          <Route path="scan/:id" element={<ScanPage />} />
          <Route path="report/:id" element={<ReportPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route
            path="dashboard"
            element={
              <RequireAuth>
                <DashboardPage />
              </RequireAuth>
            }
          />
          <Route
            path="dashboard/scans"
            element={
              <RequireAuth>
                <DashboardPage />
              </RequireAuth>
            }
          />
          <Route
            path="dashboard/scans/:id"
            element={
              <RequireAuth>
                <DashboardScanRedirect />
              </RequireAuth>
            }
          />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
